/**
 * Holds the File objects behind "new" ProductDraftMedia items, OUTSIDE Redux.
 * Files aren't serializable (and videos are far too large for base64-in-state,
 * the previous approach), so draft state carries only an `id` that keys into
 * this store.
 *
 * Lifecycle: put() when a file is picked, remove() when its item is removed,
 * clear() when the create/edit modal resets (resetToInitialState /
 * loadProductForEdit). One modal session at a time, so a single module-level
 * map is sufficient.
 */
const files = new Map<string, File>();

const DraftMediaFileStore = {
  /** Stores a file and returns its generated id. */
  put(file: File): string {
    const id = crypto.randomUUID();
    files.set(id, file);
    return id;
  },

  get(id: string): File | undefined {
    return files.get(id);
  },

  remove(id: string): void {
    files.delete(id);
  },

  clear(): void {
    files.clear();
  },
};

export default DraftMediaFileStore;
